module.exports = __webpack_public_path__ + "static/media/all_mobile_box.13a2b1f1.png";